// extracted by mini-css-extract-plugin
module.exports = {"header":"Legal_header__URMYb","toc":"Legal_toc__1SBtL","inApp":"Legal_inApp__1vVDO","contentSection":"Legal_contentSection__16RJw"};